import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";
// Fix leaflet icon issue https://github.com/PaulLeCam/react-leaflet/issues/808
import L from "leaflet";
import markerIcon2 from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";
import "semantic-ui-css/semantic.min.css";
import "unorm";
import "url-search-params-polyfill";

import App from "./components/App";
import "./serviceWorkerBridge";
import { store } from "./store";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2,
  shadowUrl: markerShadow,
});

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
((arr) => {
  arr.forEach((item) => {
    if (Object.hasOwn(item, "append")) {
      return;
    }
    Object.defineProperty(item, "append", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function append({ ...args }) {
        const argArr = Array.prototype.slice.call(args);
        const docFrag = document.createDocumentFragment();

        argArr.forEach((argItem) => {
          const isNode = argItem instanceof Node;
          docFrag.appendChild(
            isNode ? argItem : document.createTextNode(String(argItem)),
          );
        });

        this.appendChild(docFrag);
      },
    });
  });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

// Set up umami tracking in production
if (import.meta.env.VITE_STAGE === "Prod") {
  const script = document.createElement("script");
  script.src = import.meta.env.VITE_UMAMI_SCRIPT;
  script.defer = true;
  script.dataset.websiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID;
  script.id = "umami-script";
  document.head.appendChild(script);
}

if (import.meta.env.VITE_IS_PRODUCTION === "true") {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [browserTracingIntegration(), Sentry.replayIntegration()],
    environment: import.meta.env.MODE,
    normalizeDepth: 10,
    release: import.meta.env.VITE_GIT_SHA,
    maxBreadcrumbs: 50,
    denyUrls: [
      /support\.simplydo\.co\.uk/i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^webkit-masked-url:\//i,
    ],
    replaysOnErrorSampleRate: 1.0,
  });
}

const router = createBrowserRouter([{ path: "*", element: <App /> }]);
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>,
);
